import { w } from 'windstitch';

export const Wrapper = w.header(
  'w-full flex justify-center bg-[var(--marine-400)] fixed top-0 px-4 xl:px-0',
);

export const WrapperContent = w.header(
  'w-[1200px] flex justify-between flex-col sm:flex-row gap-8 py-4 items-center',
);

export const MenuWrapper = w.div(
  'hidden bg-[var(--marine-200)]  h-14 gap-4 rounded-[64px] p-2 xl:flex items-center'
);

export const MenuBtn = w.button(
  'h-10 px-4 py-2 gap-2 rounded-[24px] hover:bg-[var(--lime-500)]  hover:text-[var(--lime-800)] flex items-center'
);